<template>
    <div class="data-detail-wrapper">
        <div class="panel-title">
            <div>{{ title }}</div>
        </div>
        <div><Button class="export-btn" :text="exportBtn" :icon="exportIcon" :hoverIcon="exportIconHover" @btnClick="exportClick" /></div>
        <Table :curPage="curPage" :config="tableConfig" :dataset="tableData" :total="total" @pageChange="pageChange" class="data-detail" />
    </div>
</template>

<script>
import { dataDetailTable } from "../dataOverviewConfig.js";
import Table from "@/views/zhiji/bComponents/table/Table";
import Button from "@/views/zhiji/bComponents/buttons/Button";
import { URLs } from "@/views/zhiji/js/common/constants.js";

export default {
    name: "RobotDataDetail",
    props: ["optData"],
    components: {
        Table,
        Button
    },
    data() {
        return {
            exportIcon: "url(" + this.zhiji.staticPath() + "class-spr.png) -388px -122px",
            exportIconHover: "url(" + this.zhiji.staticPath() + "class-spr.png) -388px -122px",
            tableData: [],
            total: 0,
            curPage: 1,
            curPageLen: dataDetailTable().pageLength
        };
    },
    computed: {
        tableConfig() {
            return dataDetailTable();
        },
        title() {
            return this.$t("zhiji.overview.robotTitle");
        },
        exportBtn() {
            return this.$t("zhiji.common.export");
        }
    },
    watch: {
        optData: {
            handler(data) {
                if (!data.startTime || !data.endTime) {
                    return;
                }
                this.curPage = 1;
                let reqData = Object.assign({ type: "robot" }, this.optData, {
                    page: 1,
                    size: this.curPageLen
                });
                this.queryDataDetail(reqData);
            },
            immediate: true,
            deep: true
        },
        curPage() {
            let reqData = Object.assign({ type: "robot" }, this.optData, {
                page: this.curPage,
                size: this.curPageLen
            });
            this.queryDataDetail(reqData);
        },
        curPageLen() {
            let reqData = Object.assign({ type: "robot" }, this.optData, {
                page: this.curPage,
                size: this.curPageLen
            });
            this.queryDataDetail(reqData);
        }
    },
    methods: {
        initCurrPage() {
            this.curPage = 1;
        },
        pageChange(data) {
            if (this.curPageLen == data.pageLength && this.curPage == data.curPage) {
                return;
            }
            this.curPageLen = data.pageLength;
            this.curPage = data.curPage;
        },
        exportClick() {
            let reqUrl = URLs.EXPORT_OVERVIEW_DATA + `?start_time=${this.optData.startTime}&end_time=${this.optData.endTime}`;
            let reqUrlParam = `&type=robot&language=${this.cvtReqData(this.optData.lang)}&channel=${this.cvtReqData(this.optData.channel)}`;

            reqUrlParam = reqUrlParam.replace(/\s+/g, "");
            reqUrl = reqUrl + reqUrlParam;

            this.zhiji.requestByServiceName("getDownloadToken", reqUrl).then(result => {
                window.open(result, "_blank");
            });
        },
        cvtReqData(data) {
            return data === "all" ? "" : data;
        },
        queryDataDetail(request) {
            this.zhiji.requestByServiceName("queryDataTrend", request).then(resp => {
                this.total = resp.count;
                this.tableData = resp.list;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.data-detail-wrapper {
    background: #fff;
    margin-bottom: 16px;
    border: 1px solid #d9e4ef;
    border-radius: 4px;
    padding: 0 16px 16px 16px;

    .panel-title {
        font-size: 14px;
        color: #41475e;
        font-weight: bold;
        padding: 16px 0px 16px 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .data-detail {
        border: 1px solid #e3ecf5;
        border-top: none;
        border-radius: 4px;
    }

    .export-btn {
        font-size: 14px;
        color: #fff;
        border-radius: 30px;
        margin-bottom: 16px;
        background: #2ec2ff;
        box-shadow: 0 0 6px 2px rgba(46, 98, 151, 0.2);
        min-width: 96px;
        justify-content: center;
        &:hover {
            background: rgba(46, 194, 255, 0.8);
        }
    }
}
</style>
